export const isHrefActive = (href, pathname) => {
  if (!href) return false
  return pathname === href || pathname.startsWith(`${href}/`)
}

export const isNavItemActive = (item, pathname) => {
  if (item.href && isHrefActive(item.href, pathname)) {
    return true
  }

  if (item.items) {
    return item.items.some(child => isNavItemActive(child, pathname))
  }

  return false
}

export const hasActiveChild = (item, pathname) => {
  if (!item.items) return false
  return item.items.some(child => isNavItemActive(child, pathname))
}

export const getActiveNavItemId = (items, pathname) => {
  let activeId = null
  let longestMatch = 0

  const visit = item => {
    if (item.href && isHrefActive(item.href, pathname)) {
      const matchLength = item.href.length
      if (matchLength >= longestMatch) {
        longestMatch = matchLength
        activeId = item.id
      }
    }

    if (item.items) {
      item.items.forEach(visit)
    }
  }

  items.forEach(visit)
  return activeId
}

export const filterNavItem = (item, ctx = {}) => {
  if (!item) return null

  const { ITEM_VISIBILITY_RULES, SUB_ITEM_VISIBILITY_RULES } = ctx.rules || {}
  const itemRule = ITEM_VISIBILITY_RULES?.[item.id]
  if (itemRule && !itemRule(ctx)) {
    return null
  }

  if (item.items) {
    const filteredItems = item.items
      .filter(subItem => {
        if (!ctx.applySubItemRules) return true
        const rule = SUB_ITEM_VISIBILITY_RULES?.[subItem.id]
        return rule ? rule(ctx) : true
      })
      .map(subItem => filterNavItem(subItem, ctx))
      .filter(Boolean)

    if (filteredItems.length === 0 && !item.href) return null
    return { ...item, items: filteredItems }
  }

  return item
}

export const filterNavSection = (section, ctx = {}) => ({
  ...section,
  items: section.items.map(item => filterNavItem(item, ctx)).filter(Boolean),
})
